import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

// Hardcoded admin credentials
const ADMIN_USERS = [
  { username: 'admin1', password: 'Alldoer@2024' },
  { username: 'admin2', password: 'Alldoer@2025' }
];

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in
    const storedUser = sessionStorage.getItem('adminUser');
    if (storedUser) {
      setCurrentUser(JSON.parse(storedUser));
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  const login = (username, password) => {
    const user = ADMIN_USERS.find(
      (u) => u.username === username && u.password === password
    );

    if (user) {
      const userData = { username: user.username };
      setCurrentUser(userData);
      setIsAuthenticated(true);
      sessionStorage.setItem('adminUser', JSON.stringify(userData));
      return { success: true };
    }

    return { success: false, message: 'Invalid credentials' };
  };

  const logout = () => {
    setCurrentUser(null);
    setIsAuthenticated(false);
    sessionStorage.removeItem('adminUser');
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, currentUser, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
